import * as React from 'react';
import { SvgIcon } from '@material-ui/core';

const PlatinumUS = props => {
  const { countryCode, ...remainingProps } = props;
  return (
    <SvgIcon {...remainingProps} viewBox="26 0 70 110">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="-2395.13"
          y1="195.8"
          x2="-2395.79"
          y2="196.3"
          gradientTransform="matrix(103.84, 0, 0, -143.82, 248802.39, 28234.9)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.04" stopColor="#555042" />
          <stop offset="0.15" stopColor="#413c32" />
          <stop offset="0.26" stopColor="#343028" />
          <stop offset="0.37" stopColor="#302c25" />
          <stop offset="0.42" stopColor="#363229" />
          <stop offset="0.5" stopColor="#4a4236" />
          <stop offset="0.6" stopColor="#695e4a" />
          <stop offset="0.7" stopColor="#948467" />
          <stop offset="0.73" stopColor="#a39171" />
          <stop offset="0.86" stopColor="#c0b093" />
          <stop offset="0.95" stopColor="#d2c3a8" />
        </linearGradient>
        <radialGradient
          id="radial-gradient"
          cx="39.26"
          cy="-404.03"
          fx="31.677379693301887"
          fy="-414.90301810017695"
          r="96.17"
          gradientTransform="matrix(1, 0, 0, -1, 0, -391.15)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1" stopColor="#747b7d" />
          <stop offset="0.63" stopColor="#2f2f2f" />
          <stop offset="0.85" />
        </radialGradient>
        <radialGradient
          id="radial-gradient-2"
          cx="110.38"
          cy="-224.21"
          fx="86.37016941752685"
          fy="-241.15770387854204"
          r="80.79"
          gradientTransform="matrix(0.99, 0.11, 0.09, -0.8, -28.28, -163.02)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#8a9295" />
          <stop offset="0.13" stopColor="#858d90" />
          <stop offset="0.3" stopColor="#777e80" />
          <stop offset="0.48" stopColor="#606566" />
          <stop offset="0.68" stopColor="#404243" />
          <stop offset="0.77" stopColor="#2f2f2f" />
        </radialGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="26.17"
          y1="-394.36"
          x2="97.59"
          y2="-465.77"
          gradientTransform="matrix(1, 0, 0, -1, 0, -391.15)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.4" stopColor="#5e5f5e" />
          <stop offset="0.62" stopColor="#212121" />
        </linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <path
            fill="url(#linear-gradient)"
            d="M82.11,87.34,61.62,99.51l-20-12.12A31.52,31.52,0,0,1,26.44,60.45V6.93A5.85,5.85,0,0,1,32.3,1.08H91.66a5.85,5.85,0,0,1,5.85,5.85V60.27A31.48,31.48,0,0,1,82.11,87.34Z"
          />
          <path
            fill="#7a6854"
            d="M61.62,100.75,41.06,88.3A32.73,32.73,0,0,1,25.38,60.45V6.93A6.92,6.92,0,0,1,32.3,0H91.66a6.92,6.92,0,0,1,6.92,6.92V60.27a32.69,32.69,0,0,1-15.93,28ZM32.3,2.14a4.79,4.79,0,0,0-4.79,4.79V60.46a30.58,30.58,0,0,0,14.66,26L61.63,98.27,81.56,86.43A30.57,30.57,0,0,0,96.45,60.27V6.93a4.8,4.8,0,0,0-4.79-4.79Z"
          />
          <path
            fill="#fff"
            d="M66.85,62.19a10.87,10.87,0,0,1,5.84,9.61,1.33,1.33,0,0,1-1.32,1.33H52.6a1.33,1.33,0,1,1-.06-2.65H69.91A8.23,8.23,0,0,0,54.52,68a1.33,1.33,0,0,1-2.36-1.23h0A10.89,10.89,0,0,1,66.85,62.19Z"
          />
          <path
            fill="#fff"
            d="M54.46,75.37l.08.17a8.23,8.23,0,0,0,14.88,0,1.33,1.33,0,0,1,2.39,1.14,10.88,10.88,0,0,1-9.37,6.21H62a10.87,10.87,0,0,1-9.83-6.21,1.33,1.33,0,0,1,2.31-1.31Z"
          />
          <path
            fill="#d8d8d8"
            d="M40.16,34.06v3.38H39V29h3.23a3,3,0,0,1,2.1.69,2.62,2.62,0,0,1,0,3.67,3,3,0,0,1-2.1.69Zm0-.89h2.09a1.51,1.51,0,0,0,1.69-1.34,1.34,1.34,0,0,0,0-.28,1.68,1.68,0,0,0-.43-1.17,1.59,1.59,0,0,0-1.27-.47H40.16Z"
          />
          <path fill="#d8d8d8" d="M47.64,37.44H46.5v-9h1.14Z" />
          <path
            fill="#d8d8d8"
            d="M53.24,37.44c0-.19-.06-.36-.08-.5a2.18,2.18,0,0,1,0-.44,2.73,2.73,0,0,1-.83.76,2.18,2.18,0,0,1-1.11.3,2,2,0,0,1-1.49-.5,1.86,1.86,0,0,1-.51-1.38,1.63,1.63,0,0,1,.72-1.41,3.45,3.45,0,0,1,2-.5h1.24v-.62a1.17,1.17,0,0,0-.34-.87,1.27,1.27,0,0,0-1-.32,1.39,1.39,0,0,0-.9.27.85.85,0,0,0-.34.67H49.51v0a1.48,1.48,0,0,1,.64-1.25,3,3,0,0,1,3.47,0,2,2,0,0,1,.65,1.56v3c0,.21,0,.43,0,.65a3.15,3.15,0,0,0,.13.61Zm-1.89-.83a2.09,2.09,0,0,0,1.12-.32,1.54,1.54,0,0,0,.65-.73v-1H51.84a1.66,1.66,0,0,0-1.11.35,1,1,0,0,0-.41.81.85.85,0,0,0,.26.66,1.09,1.09,0,0,0,.77.25Z"
          />
          <path
            fill="#d8d8d8"
            d="M57.5,29.66v1.51h1.19V32H57.5v3.8a.85.85,0,0,0,.18.62.64.64,0,0,0,.49.18.86.86,0,0,0,.22,0,.66.66,0,0,0,.2-.06l.16.79a1,1,0,0,1-.38.17,2,2,0,0,1-.49.06,1.45,1.45,0,0,1-1.11-.42,1.82,1.82,0,0,1-.41-1.31V32h-1v-.85h1V29.66Z"
          />
          <path fill="#d8d8d8" d="M61.14,29.57H60V28.41h1.14Zm0,7.87H60V31.18h1.14Z" />
          <path
            fill="#d8d8d8"
            d="M63.92,31.17l.08.94a2.24,2.24,0,0,1,.78-.78,2.14,2.14,0,0,1,1.08-.27,2.05,2.05,0,0,1,1.57.59A2.6,2.6,0,0,1,68,33.49v3.95H66.84V33.51a1.67,1.67,0,0,0-.33-1.18,1.28,1.28,0,0,0-1-.34,1.76,1.76,0,0,0-.9.21,1.56,1.56,0,0,0-.58.59v4.65H62.9V31.18Z"
          />
          <path
            fill="#d8d8d8"
            d="M73.62,36.51a2.11,2.11,0,0,1-.76.78,2,2,0,0,1-1.07.27,2,2,0,0,1-1.6-.65,3,3,0,0,1-.57-2V31.18h1.14v3.7a2.37,2.37,0,0,0,.29,1.38,1.09,1.09,0,0,0,.92.38,2,2,0,0,0,1-.25,1.57,1.57,0,0,0,.6-.7V31.17h1.14v6.27h-1Z"
          />
          <path
            fill="#d8d8d8"
            d="M77.4,31.17l.08.83a2.18,2.18,0,0,1,.78-.7,2.33,2.33,0,0,1,1.1-.24,1.94,1.94,0,0,1,1.07.29,1.71,1.71,0,0,1,.67.87,2.31,2.31,0,0,1,.79-.85A2,2,0,0,1,83,31.06a1.83,1.83,0,0,1,1.51.66,3,3,0,0,1,.56,2v3.75H84V33.68a2.09,2.09,0,0,0-.32-1.31,1.18,1.18,0,0,0-.95-.39,1.23,1.23,0,0,0-1,.41,1.72,1.72,0,0,0-.42,1v4H80.16V33.68a2.09,2.09,0,0,0-.32-1.29,1.15,1.15,0,0,0-1-.41,1.5,1.5,0,0,0-.85.22,1.32,1.32,0,0,0-.52.6v4.64H76.38V31.17Z"
          />
          <path fill="#d8d8d8" d="M42.65,49.91H41.5V41.48h1.15Z" />
          <path
            fill="#d8d8d8"
            d="M45.6,43.64l.08.94a2.36,2.36,0,0,1,.79-.78,2.1,2.1,0,0,1,1.07-.27,2,2,0,0,1,1.57.59A2.65,2.65,0,0,1,49.67,46v3.95H48.53V46a1.72,1.72,0,0,0-.33-1.18,1.31,1.31,0,0,0-1-.34,1.72,1.72,0,0,0-.89.21,1.52,1.52,0,0,0-.59.59v4.65H44.58V43.64Z"
          />
          <path
            fill="#d8d8d8"
            d="M55,48.23a.78.78,0,0,0-.29-.62,2.86,2.86,0,0,0-1.08-.42,4.47,4.47,0,0,1-1.7-.66,1.36,1.36,0,0,1-.6-1.15A1.65,1.65,0,0,1,52,44.07a2.88,2.88,0,0,1,3.42,0A1.66,1.66,0,0,1,56,45.46v0H54.9a1,1,0,0,0-.36-.74,1.29,1.29,0,0,0-.9-.33,1.34,1.34,0,0,0-.9.28.85.85,0,0,0-.3.65.7.7,0,0,0,.26.57,2.92,2.92,0,0,0,1.06.37,4.43,4.43,0,0,1,1.75.69,1.4,1.4,0,0,1,.6,1.16,1.62,1.62,0,0,1-.68,1.36,3.21,3.21,0,0,1-3.65-.08A1.73,1.73,0,0,1,51.13,48v0h1.09a1.05,1.05,0,0,0,.45.89,1.73,1.73,0,0,0,1,.28,1.52,1.52,0,0,0,.95-.26A.78.78,0,0,0,55,48.23Z"
          />
          <path
            fill="#d8d8d8"
            d="M59.11,42.13v1.51H60.3v.85H59.11V48.3a.84.84,0,0,0,.19.61.62.62,0,0,0,.48.18.82.82,0,0,0,.22,0,.83.83,0,0,0,.21-.06l.15.79A1,1,0,0,1,60,50a2.14,2.14,0,0,1-.5.06,1.45,1.45,0,0,1-1.1-.42A1.74,1.74,0,0,1,58,48.3V44.49H57v-.85h1V42.13Z"
          />
          <path
            fill="#d8d8d8"
            d="M65.38,49.91c0-.19-.07-.36-.09-.5a3.27,3.27,0,0,1,0-.44,2.73,2.73,0,0,1-.83.76,2.18,2.18,0,0,1-1.11.3,2,2,0,0,1-1.49-.5,1.86,1.86,0,0,1-.51-1.38A1.62,1.62,0,0,1,62,46.74a3.4,3.4,0,0,1,2-.5h1.24v-.62a1.15,1.15,0,0,0-.34-.87,1.32,1.32,0,0,0-.95-.33,1.46,1.46,0,0,0-.9.28.84.84,0,0,0-.34.67H61.64v0a1.5,1.5,0,0,1,.64-1.25A2.65,2.65,0,0,1,64,43.53a2.59,2.59,0,0,1,1.71.54,2,2,0,0,1,.65,1.56v3c0,.22,0,.44,0,.65a3.25,3.25,0,0,0,.13.62Zm-1.9-.83a2.11,2.11,0,0,0,1.12-.32,1.49,1.49,0,0,0,.65-.73V47H64a1.71,1.71,0,0,0-1.11.35,1,1,0,0,0-.41.82.88.88,0,0,0,.26.66A1.13,1.13,0,0,0,63.48,49.08Z"
          />
          <path fill="#d8d8d8" d="M69.28,49.91H68.14v-9h1.14Z" />
          <path fill="#d8d8d8" d="M72.27,49.91H71.12v-9h1.15Z" />
          <path
            fill="#d8d8d8"
            d="M76.61,50a2.63,2.63,0,0,1-2.1-.86,3.35,3.35,0,0,1-.75-2.27v-.26a3.26,3.26,0,0,1,.78-2.23,2.39,2.39,0,0,1,1.9-.88,2.28,2.28,0,0,1,1.88.78A3.17,3.17,0,0,1,79,46.39V47h-4l0,0a2.59,2.59,0,0,0,.42,1.53,1.48,1.48,0,0,0,1.27.59,2.73,2.73,0,0,0,1-.17,2.21,2.21,0,0,0,.75-.45l.45.74a2.82,2.82,0,0,1-.89.55A3.51,3.51,0,0,1,76.61,50Zm-.17-5.6a1.22,1.22,0,0,0-1,.46A2.1,2.1,0,0,0,75,46.06v0h2.83V46a1.9,1.9,0,0,0-.34-1.13,1.21,1.21,0,0,0-1-.45Z"
          />
          <path
            fill="#d8d8d8"
            d="M83.19,44.65l-.58,0a1.27,1.27,0,0,0-.76.21,1.34,1.34,0,0,0-.48.6v4.48H80.23V43.64h1l.11.92A2.16,2.16,0,0,1,82,43.8a1.54,1.54,0,0,1,.91-.27,1,1,0,0,1,.24,0l.19,0Z"
          />
          <path fill="#fff" d="M44.72,19.56H41.25v3h4.06v.89h-5.2V15h5.14v.89h-4v2.73h3.47Z" />
          <path
            fill="#fff"
            d="M47.52,17.2l.08.94a2.24,2.24,0,0,1,.78-.78,2.14,2.14,0,0,1,1.08-.27,2.05,2.05,0,0,1,1.57.59,2.59,2.59,0,0,1,.55,1.83v4H50.44V19.54a1.71,1.71,0,0,0-.32-1.18,1.32,1.32,0,0,0-1-.34,1.78,1.78,0,0,0-.9.21,1.56,1.56,0,0,0-.58.59v4.65H46.5V17.2Z"
          />
          <path
            fill="#fff"
            d="M58.58,20.57a3.41,3.41,0,0,1-.65,2.19,2.14,2.14,0,0,1-1.79.83,2.33,2.33,0,0,1-1-.19,2,2,0,0,1-.75-.58v3.06H53.24V17.2h.87l.18.81a2.22,2.22,0,0,1,.77-.69,2.32,2.32,0,0,1,1.07-.23,2.06,2.06,0,0,1,1.8.92,4.14,4.14,0,0,1,.65,2.44Zm-1.14-.12A3.34,3.34,0,0,0,57,18.7,1.37,1.37,0,0,0,55.78,18a1.59,1.59,0,0,0-.84.23,1.64,1.64,0,0,0-.56.61v3a1.69,1.69,0,0,0,.56.6,1.61,1.61,0,0,0,.85.22A1.41,1.41,0,0,0,57,22.11a2.62,2.62,0,0,0,.42-1.54Z"
          />
          <path
            fill="#fff"
            d="M61.12,18a2.34,2.34,0,0,1,.8-.7,2.1,2.1,0,0,1,1-.25,2,2,0,0,1,1.57.6,2.62,2.62,0,0,1,.55,1.85v3.93H63.94V19.53a1.64,1.64,0,0,0-.33-1.15,1.29,1.29,0,0,0-1-.37,1.94,1.94,0,0,0-.89.2,1.64,1.64,0,0,0-.61.56v4.7H60v-9h1.14Z"
          />
          <path
            fill="#fff"
            d="M70.58,23.47c0-.19-.07-.36-.09-.5a2.18,2.18,0,0,1,0-.44,2.58,2.58,0,0,1-.83.75,2.19,2.19,0,0,1-1.11.31,2,2,0,0,1-1.49-.5,1.86,1.86,0,0,1-.51-1.38,1.62,1.62,0,0,1,.73-1.41,3.32,3.32,0,0,1,2-.5h1.24v-.63a1.18,1.18,0,0,0-.34-.87,1.36,1.36,0,0,0-1-.32,1.46,1.46,0,0,0-.9.28.84.84,0,0,0-.34.67H66.84v0a1.5,1.5,0,0,1,.64-1.25,2.71,2.71,0,0,1,1.76-.57,2.65,2.65,0,0,1,1.71.55,1.91,1.91,0,0,1,.64,1.56v3c0,.22,0,.44,0,.65a3.25,3.25,0,0,0,.13.62Zm-1.9-.83a2.09,2.09,0,0,0,1.12-.32,1.54,1.54,0,0,0,.65-.73v-1H69.17a1.66,1.66,0,0,0-1.11.35,1,1,0,0,0-.41.81.85.85,0,0,0,.26.66,1.09,1.09,0,0,0,.77.25Z"
          />
          <path
            fill="#fff"
            d="M76.89,21.78a.78.78,0,0,0-.29-.61,2.69,2.69,0,0,0-1.09-.42,4.6,4.6,0,0,1-1.7-.66,1.38,1.38,0,0,1-.59-1.15,1.66,1.66,0,0,1,.65-1.31,2.9,2.9,0,0,1,3.42,0A1.66,1.66,0,0,1,77.92,19v0H76.82a1,1,0,0,0-.36-.73,1.24,1.24,0,0,0-.9-.33,1.28,1.28,0,0,0-.9.27.85.85,0,0,0-.3.65.7.7,0,0,0,.26.57,2.74,2.74,0,0,0,1.06.37,4.59,4.59,0,0,1,1.75.69,1.4,1.4,0,0,1,.6,1.17,1.67,1.67,0,0,1-.68,1.36A3.26,3.26,0,0,1,73.7,23a1.74,1.74,0,0,1-.65-1.42v0h1.09a1,1,0,0,0,.45.89,1.73,1.73,0,0,0,1,.28,1.52,1.52,0,0,0,1-.26A.78.78,0,0,0,76.89,21.78Z"
          />
          <path
            fill="#fff"
            d="M82,23.59a2.65,2.65,0,0,1-2.1-.86,3.31,3.31,0,0,1-.76-2.27V20.2A3.26,3.26,0,0,1,80,18a2.42,2.42,0,0,1,1.91-.88,2.23,2.23,0,0,1,1.88.78A3.23,3.23,0,0,1,84.38,20v.6h-4l0,0a2.66,2.66,0,0,0,.42,1.53,1.49,1.49,0,0,0,1.28.59,2.9,2.9,0,0,0,1-.17,2.25,2.25,0,0,0,.76-.45l.44.74a2.82,2.82,0,0,1-.89.55A3.51,3.51,0,0,1,82,23.59ZM81.86,18a1.25,1.25,0,0,0-1,.47,2.1,2.1,0,0,0-.48,1.17v0h2.82v-.09a1.83,1.83,0,0,0-.33-1.13,1.19,1.19,0,0,0-1-.44Z"
          />
          <g id="Platinum">
            <g id="shield">
              <path
                id="base"
                fill="url(#radial-gradient)"
                d="M96.44,60.22V6.9a4.77,4.77,0,0,0-4.76-4.77H32.31A4.77,4.77,0,0,0,27.55,6.9V60.43a30.56,30.56,0,0,0,14.64,26L61.67,98.26,81.58,86.38A30.42,30.42,0,0,0,96.44,60.22Z"
              />
              <path
                id="highlight"
                fill="url(#radial-gradient-2)"
                d="M91.68,2.13H32.31A4.77,4.77,0,0,0,27.55,6.9V59.15A2.08,2.08,0,0,1,28,58.3C28.76,57.59,93.74,7.75,95.16,7a2.86,2.86,0,0,1,1.28-.36A4.76,4.76,0,0,0,91.68,2.13Z"
              />
              <path
                id="edge"
                fill="url(#linear-gradient-2)"
                d="M61.6,100.75,41.06,88.3A32.88,32.88,0,0,1,25.34,60.43V6.9A6.91,6.91,0,0,1,32.24,0H91.61A6.9,6.9,0,0,1,98.5,6.9V60.22a32.72,32.72,0,0,1-15.92,28ZM32.31,2.13A4.77,4.77,0,0,0,27.55,6.9V60.43a30.56,30.56,0,0,0,14.64,26L61.67,98.26,81.58,86.38A30.61,30.61,0,0,0,96.44,60.22V6.9a4.77,4.77,0,0,0-4.76-4.77Z"
              />
            </g>
            <g id="logo">
              <path
                fill="#fff"
                d="M66.86,62.14a10.83,10.83,0,0,1,5.83,9.6,1.34,1.34,0,0,1-1.35,1.35H52.57a1.35,1.35,0,1,1,0-2.7H69.92A8.21,8.21,0,0,0,54.56,67.9a1.32,1.32,0,1,1-2.34-1.21A10.86,10.86,0,0,1,66.86,62.14Z"
              />
              <path
                fill="#fff"
                d="M54.42,75.36a.29.29,0,0,0,.07.15,8.22,8.22,0,0,0,10.95,3.91,8.08,8.08,0,0,0,3.91-3.91,1.29,1.29,0,0,1,1.78-.5,1.28,1.28,0,0,1,.57,1.63,10.81,10.81,0,0,1-9.39,6.19h-.42a10.84,10.84,0,0,1-9.81-6.19,1.28,1.28,0,0,1,.49-1.77A1.35,1.35,0,0,1,54.42,75.36Z"
              />
            </g>
            <g id="text">
              <g id="Installer">
                <path fill="#fff" d="M42.62,49.91H41.48V41.45h1.14Z" />
                <path
                  fill="#fff"
                  d="M45.61,43.65l.07.93a2.52,2.52,0,0,1,.78-.78,1.67,1.67,0,0,1,1.07-.29,2.12,2.12,0,0,1,1.56.57,2.73,2.73,0,0,1,.57,1.85v4H48.52V46a1.92,1.92,0,0,0-.35-1.21,1.44,1.44,0,0,0-1-.35,1.58,1.58,0,0,0-1.49.78v4.62H44.54V43.58h1.07Z"
                />
                <path
                  fill="#fff"
                  d="M54.92,48.2a.79.79,0,0,0-.28-.64,2.6,2.6,0,0,0-1.07-.42,4.85,4.85,0,0,1-1.71-.64,1.41,1.41,0,0,1-.57-1.14,1.64,1.64,0,0,1,.64-1.28,2.85,2.85,0,0,1,3.42,0A1.77,1.77,0,0,1,56,45.43H54.92a1,1,0,0,0-.36-.71,1.34,1.34,0,0,0-.92-.35,1.2,1.2,0,0,0-.92.28.85.85,0,0,0-.29.64.64.64,0,0,0,.29.57,2,2,0,0,0,1.06.35,4.88,4.88,0,0,1,1.78.71,1.3,1.3,0,0,1,.57,1.14,1.63,1.63,0,0,1-.64,1.35,2.76,2.76,0,0,1-1.78.5,2.84,2.84,0,0,1-1.92-.64,1.51,1.51,0,0,1-.64-1.42h1.07a1,1,0,0,0,.42.92,1.61,1.61,0,0,0,1,.29,1.16,1.16,0,0,0,.92-.29C54.78,48.56,54.92,48.49,54.92,48.2Z"
                />
                <path
                  fill="#fff"
                  d="M59.11,42.09v1.49h1.21v.86H59.11v3.84a.9.9,0,0,0,.22.64.64.64,0,0,0,.5.21H60c.07,0,.14-.07.21-.07l.14.78A.53.53,0,0,1,60,50a1.24,1.24,0,0,1-.5.07,1.52,1.52,0,0,1-1.14-.42A1.83,1.83,0,0,1,58,48.28V44.44H57v-.86h1V42.09Z"
                />
                <path
                  fill="#fff"
                  d="M65.37,49.91a1.39,1.39,0,0,1-.07-.5.89.89,0,0,0-.07-.42,3.06,3.06,0,0,1-.85.78,2.15,2.15,0,0,1-1.14.28,2,2,0,0,1-1.49-.49,1.78,1.78,0,0,1-.5-1.36A1.67,1.67,0,0,1,62,46.78a3.36,3.36,0,0,1,2-.5h1.21v-.64a1.15,1.15,0,0,0-.36-.85,1.36,1.36,0,0,0-.92-.35,1.46,1.46,0,0,0-.93.28,1,1,0,0,0-.35.64H61.53a1.87,1.87,0,0,1,.64-1.28A2.85,2.85,0,0,1,64,43.51a2.64,2.64,0,0,1,1.71.57,1.91,1.91,0,0,1,.64,1.56v3.63a2.1,2.1,0,0,0,.14.64Zm-1.92-.85a2,2,0,0,0,1.14-.29,1.2,1.2,0,0,0,.64-.71v-1H64a2,2,0,0,0-1.14.35,1,1,0,0,0-.42.78.69.69,0,0,0,.28.64A1.37,1.37,0,0,0,63.45,49.06Z"
                />
                <path fill="#fff" d="M69.28,49.91H68.14v-9h1.14Z" />
                <path fill="#fff" d="M72.27,49.91H71.13v-9h1.14Z" />
                <path
                  fill="#fff"
                  d="M76.6,50a2.68,2.68,0,0,1-2.13-.85,3.38,3.38,0,0,1-.78-2.28v-.28a3.15,3.15,0,0,1,.78-2.2,2.66,2.66,0,0,1,3.84-.08A3.11,3.11,0,0,1,79,46.36v.56H75a2.69,2.69,0,0,0,.43,1.57,1.37,1.37,0,0,0,1.28.57,4.22,4.22,0,0,0,1-.14,2.91,2.91,0,0,0,.78-.43l.43.71a2.58,2.58,0,0,1-.85.57A4.4,4.4,0,0,1,76.6,50Zm-.14-5.54a1.29,1.29,0,0,0-1,.42,2.06,2.06,0,0,0-.5,1.21h2.84V46a2,2,0,0,0-.35-1.14A1.22,1.22,0,0,0,76.46,44.44Z"
                />
                <path
                  fill="#fff"
                  d="M83.22,44.65h-.57a1.42,1.42,0,0,0-.78.21,1.82,1.82,0,0,0-.5.57v4.48H80.23V43.65h1l.14.93A2.19,2.19,0,0,1,82,43.8a1.28,1.28,0,0,1,.92-.29h.22a.26.26,0,0,1,.21.07Z"
                />
              </g>
              <g id="Platinum-2" data-name="Platinum">
                <path
                  fill="#fff"
                  d="M40.13,34.06v3.41H39V29h3.2a2.87,2.87,0,0,1,2.14.71,2.58,2.58,0,0,1,0,3.7,3.25,3.25,0,0,1-2.14.71H40.13Zm0-.93h2.06a1.75,1.75,0,0,0,1.28-.42,1.62,1.62,0,0,0,.43-1.14,1.59,1.59,0,0,0-.43-1.14,1.77,1.77,0,0,0-1.28-.5H40.13Z"
                />
                <path fill="#fff" d="M47.6,37.4H46.46v-9H47.6Z" />
                <path
                  fill="#fff"
                  d="M53.21,37.4a1.44,1.44,0,0,1-.07-.5,1,1,0,0,0-.07-.43,3.09,3.09,0,0,1-.85.79,2.12,2.12,0,0,1-1.14.28,2,2,0,0,1-1.49-.5,1.74,1.74,0,0,1-.5-1.35,1.64,1.64,0,0,1,.71-1.42,3.29,3.29,0,0,1,2-.5H53v-.64a1.15,1.15,0,0,0-.36-.85,1.34,1.34,0,0,0-.92-.36,1.37,1.37,0,0,0-.92.29.94.94,0,0,0-.36.64H49.37A1.85,1.85,0,0,1,50,31.57,2.79,2.79,0,0,1,51.79,31a2.59,2.59,0,0,1,1.71.57,1.89,1.89,0,0,1,.64,1.56v3.63a2.17,2.17,0,0,0,.14.64Zm-1.85-.78a2.11,2.11,0,0,0,1.14-.29,1.2,1.2,0,0,0,.64-.71v-1H51.86a2,2,0,0,0-1.14.36,1,1,0,0,0-.42.78.69.69,0,0,0,.28.64A1.73,1.73,0,0,0,51.36,36.62Z"
                />
                <path
                  fill="#fff"
                  d="M57.48,29.65v1.49h1.21V32H57.48v3.84a.87.87,0,0,0,.21.64.63.63,0,0,0,.5.22h.21c.07,0,.15-.07.22-.07l.14.78a.54.54,0,0,1-.36.14h-.57a1.47,1.47,0,0,1-1.13-.43,1.78,1.78,0,0,1-.43-1.35V31.92h-1v-.78h1V29.65Z"
                />
                <path fill="#fff" d="M61.11,29.58H60V28.44h1.14Zm0,7.82H60V31.14h1.14Z" />
                <path
                  fill="#fff"
                  d="M63.88,31.14l.07.93a2.8,2.8,0,0,1,.78-.79A1.75,1.75,0,0,1,65.8,31a2.06,2.06,0,0,1,1.56.57,2.69,2.69,0,0,1,.57,1.85v4H66.79V33.49a1.9,1.9,0,0,0-.35-1.21,1.44,1.44,0,0,0-1-.36,1.87,1.87,0,0,0-.92.22,1.94,1.94,0,0,0-.57.57v4.62H62.81V31.14Z"
                />
                <path
                  fill="#fff"
                  d="M73.62,36.47a2.11,2.11,0,0,1-.78.79,1.89,1.89,0,0,1-1.07.28,1.86,1.86,0,0,1-1.56-.64,3.23,3.23,0,0,1-.57-2.06v-3.7h1.13v3.7a2.12,2.12,0,0,0,.29,1.35,1,1,0,0,0,.92.35,2.12,2.12,0,0,0,1-.21,1.15,1.15,0,0,0,.57-.71V31.14h1.13V37.4h-1Z"
                />
                <path
                  fill="#fff"
                  d="M77.39,31.14l.07.85a4.07,4.07,0,0,1,.78-.71,2.62,2.62,0,0,1,1.07-.21,1.85,1.85,0,0,1,1.06.28,1.92,1.92,0,0,1,.64.86,3.26,3.26,0,0,1,.78-.86,2,2,0,0,1,1.14-.28,1.85,1.85,0,0,1,1.5.64,3.07,3.07,0,0,1,.56,2v3.77H83.86V33.7a1.83,1.83,0,0,0-.29-1.28,1,1,0,0,0-.92-.35,1.17,1.17,0,0,0-.93.42,2.54,2.54,0,0,0-.42,1v4H80.16V33.77a2.08,2.08,0,0,0-.36-1.28,1,1,0,0,0-.92-.42,1.51,1.51,0,0,0-.85.21,1.19,1.19,0,0,0-.5.57v4.62H76.39V31.14Z"
                />
              </g>
              <g id="Enphase">
                <path fill="#fff" d="M41.34,19H37.22v3.13h4.83v1.42H35.44V13.37H42v1.42H37.15v2.84h4.19Z" />
                <path
                  fill="#fff"
                  d="M44.89,16l.08.85a2.8,2.8,0,0,1,2.2-1c1.56,0,2.35.93,2.42,2.71v5H47.88V18.7a1.51,1.51,0,0,0-.28-1.07,1.44,1.44,0,0,0-1-.35,1.47,1.47,0,0,0-1.49.92v5.33H43.4V16Z"
                />
                <path
                  fill="#fff"
                  d="M57.83,19.84a4.73,4.73,0,0,1-.78,2.77,2.44,2.44,0,0,1-2.13,1.07,2.68,2.68,0,0,1-2-.79v3.56H51.22V16h1.57l.07.78a2.54,2.54,0,0,1,2-.93,2.57,2.57,0,0,1,2.13,1,4.66,4.66,0,0,1,.78,2.84v.15Zm-1.7-.15a3,3,0,0,0-.43-1.77,1.42,1.42,0,0,0-1.28-.64,1.52,1.52,0,0,0-1.49.85v3.34a1.67,1.67,0,0,0,2.77.21A3.14,3.14,0,0,0,56.13,19.69Z"
                />
                <path
                  fill="#fff"
                  d="M60.89,16.78A2.67,2.67,0,0,1,63,15.85c1.64,0,2.42.93,2.42,2.78v4.9H63.66V18.7a1.5,1.5,0,0,0-.35-1.07,1.42,1.42,0,0,0-1-.35,1.48,1.48,0,0,0-1.49.92v5.33H59.11V12.87h1.71v3.91Z"
                />
                <path
                  fill="#fff"
                  d="M71.63,23.53a3.17,3.17,0,0,1-.22-.71,2.84,2.84,0,0,1-3.83.22,2,2,0,0,1-.72-1.57,2.1,2.1,0,0,1,.93-1.85A4.44,4.44,0,0,1,70.35,19h1.06v-.49a1.36,1.36,0,0,0-.35-.93,1.42,1.42,0,0,0-1-.35,1.32,1.32,0,0,0-.92.28,1,1,0,0,0-.36.71h-1.7a1.77,1.77,0,0,1,.42-1.14,2.87,2.87,0,0,1,1.14-.85,3.91,3.91,0,0,1,1.57-.28,3.43,3.43,0,0,1,2.13.64,2.12,2.12,0,0,1,.78,1.84v3.42a3.43,3.43,0,0,0,.29,1.63v.14H71.63Zm-1.85-1.21a2,2,0,0,0,.92-.21,1.33,1.33,0,0,0,.64-.64V20.05h-.85a2.53,2.53,0,0,0-1.42.36,1,1,0,0,0-.5.92,1,1,0,0,0,.36.78A1.1,1.1,0,0,0,69.78,22.32Z"
                />
                <path
                  fill="#fff"
                  d="M79,21.47a1,1,0,0,0-.35-.71,3.1,3.1,0,0,0-1.21-.43A11.59,11.59,0,0,1,76,19.91a1.94,1.94,0,0,1-1.28-1.78,2,2,0,0,1,.85-1.64,3.29,3.29,0,0,1,2.06-.64,3.58,3.58,0,0,1,2.21.64,2.06,2.06,0,0,1,.85,1.71H79a1,1,0,0,0-.35-.78,1.48,1.48,0,0,0-1.85-.07.77.77,0,0,0-.36.71.63.63,0,0,0,.36.57,4.23,4.23,0,0,0,1.35.42,5.27,5.27,0,0,1,1.56.5,3.08,3.08,0,0,1,.86.71,1.67,1.67,0,0,1,.28,1A1.88,1.88,0,0,1,80,22.89a3.52,3.52,0,0,1-2.21.64,4,4,0,0,1-1.63-.35A2.45,2.45,0,0,1,75,22.25,2,2,0,0,1,74.61,21h1.64a1.06,1.06,0,0,0,.43.93,1.81,1.81,0,0,0,1.13.35,1.41,1.41,0,0,0,1-.28C79,21.76,79,21.76,79,21.47Z"
                />
                <path
                  fill="#fff"
                  d="M85.49,23.68a3.79,3.79,0,0,1-2.63-1,3.7,3.7,0,0,1-1-2.7v-.21a4.41,4.41,0,0,1,.42-2,3.32,3.32,0,0,1,1.21-1.35,3.75,3.75,0,0,1,1.78-.49,2.88,2.88,0,0,1,2.34,1,4.44,4.44,0,0,1,.86,2.77v.72H83.57a2.47,2.47,0,0,0,.64,1.49,2,2,0,0,0,1.35.57,2.29,2.29,0,0,0,1.92-.93l.93.86a3.58,3.58,0,0,1-1.21,1.06A3.29,3.29,0,0,1,85.49,23.68Zm-.21-6.47a1.34,1.34,0,0,0-1.14.49,2.68,2.68,0,0,0-.57,1.35h3.27v-.14a2.75,2.75,0,0,0-.42-1.28A1.52,1.52,0,0,0,85.28,17.21Z"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default PlatinumUS;
